import { TGetE2eLabelResponse } from '../../../../node/services/getE2eLabel';
import { EContainerTypes } from '../types';

export function getInitialStep(getE2eLabelResponse: TGetE2eLabelResponse | null) {
  // Произошла ошибка при запросе статуса лейбла, тогда просто не показываем баннер
  if (!getE2eLabelResponse || getE2eLabelResponse.isFallback) {
    return EContainerTypes.NullContainer;
  }
  if (!getE2eLabelResponse.isAnyLabelSet) {
    return EContainerTypes.IsMorgageQuestion;
  }
  if (getE2eLabelResponse.isOfferLabelSet) {
    return EContainerTypes.LabelAdded;
  }

  return EContainerTypes.AddLabelWithoutProfiling;
}
